import ExpensesList from './_ExpensesList';

export default ExpensesList;
